import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Upload } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import { colors, globals } from '../../../styles/settings';
import Label from '../../label';
import styled from 'styled-components';
import { environments } from 'shared/utils/environments';
import axios from 'shared/utils/axios';

const StyledUpload = styled(Upload).attrs(({ width = 128, height = 128 }) => ({ width, height }))`
  .ant-upload-list-picture-card-container,
  .ant-upload {
    width: ${props => props.width}px !important;
    height: ${props => props.height}px !important;
  }
`;

export function ImageUploadControl({ name, value, placeholder, onChange, settings = {} }) {
  const { maxCount = 1, multiple } = settings;
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  
  const defaultFileList = useMemo(() => {
    if (!value) return [];
    const list = multiple ? value : [value];
    return list?.map((url, index) => ({
      url,
      uid: `${index}`,
      name: url?.split('/').pop(),
      type: null,
      originFileObj: null,
      size: null,
      status: 'done',
    }));
  }, [multiple, value]);
  
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  // upload image function start
  const [progress, setProgress] = useState(0);
  const [apiUrl, setApiUrl] = useState(environments.apiUrl+'/image/upload');
  useEffect(()=>{
    if(settings?.fileType === 'file'){
      setApiUrl(environments.apiUrl+'/file/upload');
    }
  }, []);
  const uploadImage = async options => {
    const { onSuccess, onError, file, onProgress } = options;
    const fmData = new FormData();
    const config = {
      headers: { 
        'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
        authorization: `Bearer ${localStorage.getItem('cofe-district:id_token')}`,
      },
      onUploadProgress: event => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgress(percent);
        if (percent === 100) {
          setTimeout(() => setProgress(0), 1000);
        }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      }
    };
    fmData.append("file", file);
    try {
      const res = await axios.post(
        apiUrl,
        fmData,
        config
      );

      onSuccess("Ok");
      if (res?.status === 200) {
        fileList.push(res?.data?.file);
        update(fileList);
      }
      
    } catch (err) {
      console.log("Eroor: ", err);
      const error = new Error("Some error");
      onError({ err });
    }
  };
  // upload image function end

  const update = useCallback(
    list => {
      const imageUrls = [];
      list?.map(({ url, location }) => {
        if(url !==undefined || location !== undefined){
          imageUrls.push(url || location);
        }
      });
      const value = multiple ? imageUrls : imageUrls[0] ?? null;
      onChange({ target: { name, value } });
    },
    [multiple, onChange]
  );

  const handleChange = useCallback(
    ({ fileList }) => {
      setFileList(fileList);
    },
    [setLoading, update]
  );
  
  const handleRemove = useCallback(
    file => {
      const index = fileList.findIndex(({ uid }) => uid === file.uid);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      update(newFileList);
    },
    [fileList, update]
  );

  useEffect(() => {
    setFileList(defaultFileList);
  }, [defaultFileList]);

  return (
    <Flex flexDirection="column">
      {placeholder && (
        <Label mb={2} color={colors.secondaryTextColor} fontSize={globals.fontSizeSmall} mt={12} width={[1, 250]}>
          {placeholder}
        </Label>
      )}
      <StyledUpload
        name={name}
        customRequest={uploadImage}
        listType="picture-card"
        defaultFileList={defaultFileList}
        fileList={fileList}
        onChange={handleChange}
        onRemove={handleRemove}
        {...settings}
      >
        {maxCount > fileList?.length ? uploadButton : null}
      </StyledUpload>
    </Flex>
  );
}

ImageUploadControl.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
